function t(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n, o) {
    a[++e] = [o, n];
  }), a;
}
var u = t;
export {
  u as default
};
//# sourceMappingURL=_mapToArray.js.map
